<div class="login-container">
  <div class="card">
    <div class="card-body text-center">
      <h3>Verificando tu identidad...</h3>
      <p class="text-muted">Por favor espera un momento</p>
    </div>
  </div>
</div>
